import { useMemo } from 'react';
import { FieldValues, UseFormGetValues } from 'react-hook-form';

import { useTranslation } from '@/hooks/useTranslation';
import { DataModelAttribute, DataModelAttributeTypeName} from '@/types/DataModel';
import { Organization } from '@/types/Organization';
import { User } from '@/types/User';

import { generateCollectionAttributeColumns } from '../../Collection/columns';

export const useMultiReferenceColumns = (
    attribute: DataModelAttribute,
    memberAttributes: DataModelAttribute[],
    fieldPath: string,
    fields: any[],
    organization: Organization | undefined,
    remove: (index: number) => void,
    user: User | undefined,
    readonly: boolean,
    getValues?: UseFormGetValues<FieldValues>
) => {
    const { t } = useTranslation();
    const columns = useMemo(() =>
        generateCollectionAttributeColumns(
            attribute,
            memberAttributes,
            fieldPath,
            fields,
            organization,
            remove,
            DataModelAttributeTypeName.MultiReference,
            user,
            [],
            readonly,
            t,
            getValues
        // eslint-disable-next-line react-hooks/exhaustive-deps
        ), [fields, readonly, t, getValues, memberAttributes]);

    return columns;
};

